<nav aria-label="breadcrumb">
  <ul class="breadcrumb">
    <li *ngFor="let crumb of breadcrumbs; let last = last" [class.active]="last">
        <mat-icon *ngIf="crumb.icon" [fontIcon]="crumb.icon"></mat-icon>
        <a class="crumb-label" *ngIf="!last" [routerLink]="crumb.url">{{ crumb.label }}</a>
        <span class="crumb-label" *ngIf="last">{{ crumb.label }}</span>
    </li>
  </ul>
</nav>
